import { type MiddlewareState } from "@floating-ui/dom";
import { getPaddingObject, type Padding } from "@floating-ui/utils";

// Floating UI middleware that ensures that the floating element is contained inside the given boundary. Mainly used
// for cases where the reference element is bigger than the boundary.
export const contain = (boundary: Element, options: { padding: Padding } = { padding: 0 }) => ({
  name: "contain",
  fn: ({ x, y, elements }: MiddlewareState) => {
    const { floating } = elements;
    const paddingObject = getPaddingObject(options.padding);
    const scrollRect = boundary.getBoundingClientRect();

    if (y < scrollRect.top + paddingObject.top) {
      y = scrollRect.top + paddingObject.top;
    } else if (y + floating.offsetHeight > scrollRect.bottom - paddingObject.bottom) {
      y = scrollRect.bottom - floating.offsetHeight - paddingObject.bottom;
    }

    if (x < scrollRect.left + paddingObject.left) {
      x = scrollRect.left + paddingObject.left;
    } else if (x + floating.offsetWidth > scrollRect.right - paddingObject.right) {
      x = scrollRect.right - floating.offsetWidth - paddingObject.right;
    }

    return { x, y };
  },
});
